/** CT programs that publish log lists. Firefox derives its list from Chrome's, so it is not separate. */
export type ProgramId = 'chrome' | 'apple' | 'custom';

export interface ListSource {
  id: string;
  program: ProgramId;
  label: string;
  description: string;
  url: string;
}

export const BUILTIN_SOURCES: ListSource[] = [
  {
    id: 'google',
    program: 'chrome',
    label: 'Google / Chrome',
    description: 'all_logs_list.json — every log Chrome knows, with its Chrome state (also what Firefox uses)',
    url: 'https://www.gstatic.com/ct/log_list/v3/all_logs_list.json',
  },
  {
    id: 'apple',
    program: 'apple',
    label: 'Apple',
    description: 'current_log_list.json — Apple\'s states, including many historical (rejected/retired) logs',
    url: 'https://valid.apple.com/ct/log_list/current_log_list.json',
  },
];

export const PROGRAM_LABEL: Record<ProgramId, string> = { chrome: 'Chrome', apple: 'Apple', custom: 'Custom list' };
/** Priority when two lists describe the same log: the earlier program supplies the base fields. */
export const PROGRAM_PRIORITY: ProgramId[] = ['chrome', 'apple', 'custom'];
